import { MyTrans } from '@halo/ui-react';
import { OptionsArray } from '@halo/utils';

export const expireTimeOptions = new OptionsArray([
  {
    key: 'minute',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesMinute1" />,
    text: ['1', 'm'],
    value: 1 * 60 * 1000,
  },
  {
    key: 'hour',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesHour1" />,
    text: ['1', 'h'],
    value: 1 * 60 * 60 * 1000,
  },
  {
    key: 'day',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesDay1" />,
    text: ['1', 'd'],
    value: 1 * 24 * 60 * 60 * 1000,
  },
  {
    key: 'week',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesWeek1" />,
    text: ['1', 'w'],
    value: 1 * 7 * 24 * 60 * 60 * 1000,
  },
  {
    key: 'month',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesMonth1" />,
    text: ['1', 'M'],
    value: 30 * 24 * 60 * 60 * 1000,
  },
  {
    key: 'sixMonths',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesMonth6" />,
    text: ['6', 'M'],
    value: 180 * 24 * 60 * 60 * 1000,
  },
  {
    key: 'year',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesYear1" />,
    text: ['1', 'Y'],
    value: 365 * 24 * 60 * 60 * 1000,
  },
  {
    key: 'never',
    label: <MyTrans i18nKey="chatSettings.autoDeleteMessagesNever" />,
    text: ['N', ''],
    value: 0,
  },
]);

export const defaultExpireTimeValue = expireTimeOptions.findValue('week')!;
